import { Card, FioDeSinal, TipoNumeroTag } from "@zaphub/ui";
import { Outlet } from "react-router-dom";

import { Logo } from "../components/Logo";

const CANAIS = [
  { tipo: "OFICIAL", texto: "Campanhas com template aprovado e captação de leads." },
  { tipo: "NAO_OFICIAL", texto: "Conversa direta com os leads, sem cobrança por mensagem." },
] as const;

const PASSOS = [
  { titulo: "Conecte o número", detalhe: "QR code no não oficial, cadastro na Meta no oficial." },
  { titulo: "Ligue ao seu sistema", detalhe: "API REST, webhooks assinados e RabbitMQ." },
  { titulo: "Acompanhe a economia", detalhe: "Contador entre o preço Utility e o Marketing." },
];

/** Casca das telas públicas (entrar, cadastro, recuperação de senha). */
export default function AuthLayout() {
  return (
    <div className="grid min-h-screen lg:grid-cols-[1fr_1.1fr]">
      <main className="flex flex-col justify-center px-6 py-10 sm:px-12">
        <Logo className="mb-10" />
        <div className="mx-auto w-full max-w-sm">
          <Outlet />
        </div>
      </main>
      {/* `dark` fixo: o painel é claro, mas este lado usa os tokens do tema escuro da landing. */}
      <aside className="dark grao relative hidden overflow-hidden bg-background p-12 text-foreground lg:flex lg:flex-col lg:justify-between xl:p-16">
        <div className="grid max-w-md gap-10">
          <Card className="tick divide-y bg-card/60 p-0">
            {CANAIS.map((c) => (
              <div key={c.tipo} className="grid gap-2 p-5">
                <TipoNumeroTag tipo={c.tipo} className="justify-self-start" />
                <p className="text-sm text-muted-foreground">{c.texto}</p>
              </div>
            ))}
          </Card>
          <FioDeSinal passos={PASSOS} ativo={2} />
        </div>
        <div className="mt-12 max-w-md">
          <p className="text-balance font-display text-3xl font-semibold leading-tight xl:text-4xl">
            Conecte o WhatsApp ao seu sistema.
          </p>
          <p className="mt-3 text-sm text-muted-foreground">
            API Oficial para campanhas e captação. Números não oficiais para conversar com os leads. Cobrança só por
            número.
          </p>
        </div>
      </aside>
    </div>
  );
}
